export default __webpack_public_path__ + "static/media/fMaltoBuza36.685a0cea.png";